import React, { useState, useEffect, useRef, Dispatch, ChangeEvent } from "react";
import { isEmpty } from "lodash";
import { Field, reduxForm } from "redux-form";
import RenderTypeahead from "../../../shared-components/Typeahead";
import { AdvanceSearchFormType } from "../../../models/common.models";
import commonActions, { resetQuickSearchSelectedWorkItemStatus, resetQuickSearchSelectedWorkItemSuppress, resetQuickSearchSelectedWorkItemType, setGlobalSearchText} from "../../../common.actions";
import { useDispatch, useSelector } from "react-redux";
import { FormControl } from "react-bootstrap";

type Option = {
    text: string;
    value: string;
    key: string;
  };
interface Props {
    onAdvanceSearchSubmit: (formData: any, type: string) => {};
    toggleAdvanceSearchVisibility?: () => void;
    committeeData: any;
    wiListData: any;
    witnListData: any;
    standardListData: any;
    setAdvWorkitemSearchFormData: any;
    wiAdvanceSearchFormData: any;
    ballotGlobalSearchTextRef: any;
    wiStatusOption: Option[];
}

const AdvanceSearchWorkitem: React.FC<Props> = (props) => {
    const dispatch = useDispatch();
    const { onAdvanceSearchSubmit, committeeData, wiListData, witnListData, standardListData, ballotGlobalSearchTextRef } = props;
    const [selectedBallotDesignation, setSelectedBallotDesignation] = useState<Array<string>>([]);
    const [selectedWI, setSelectedWI] = useState<Array<string>>([]);
    const [selectedWITN, setSelectedWITN] = useState<Array<string>>([]);
    const [selectedStandard, setSelectedStandard] = useState<Array<string>>([]);
    const [standardOptions, setStandardOptions] = useState<Array<string>>([]);

    const [selectedWICommitteeSubcommitteeSection, setSelectedWICommitteeSubcommitteeSection] = useState<Array<string>>([]);
    const advSearchButtonRef = useRef<HTMLButtonElement>(null);
    const [selectedWIStatus, setSelectedWIStatus] = useState(props.wiAdvanceSearchFormData?.selectedWIStatus || "all");
    const quickFilter = useSelector((state: any) => state.workItemReducer.quickFilters);
    const [clearAllTypeaheds, setClearAllTypeaheds] = useState<boolean>(false);
    const [formData, setFormData] = useState({});
    const [customClass, setCustomClass] = useState("advance-ballot-search");
    const [wiTitle, setWITitle] = useState<string>();

    useEffect(() => {
        setStandardOptions(standardListData);
    }, [standardListData])

    useEffect(() => {
        const formFieldData: any = {};
        if (props.wiAdvanceSearchFormData?.selectedWI) {
            setSelectedWI(props.wiAdvanceSearchFormData.selectedWI);
            formFieldData.selectedWI = props.wiAdvanceSearchFormData.selectedWI;
        }
        if (props.wiAdvanceSearchFormData?.selectedWITN) {
            setSelectedWITN(props.wiAdvanceSearchFormData.selectedWITN);
            formFieldData.selectedWITN = props.wiAdvanceSearchFormData.selectedWITN;
        }
        if (props.wiAdvanceSearchFormData?.wiTitle) {
            setWITitle(props.wiAdvanceSearchFormData.wiTitle);
            formFieldData.wiTitle = props.wiAdvanceSearchFormData.wiTitle;
        }
        if (props.wiAdvanceSearchFormData?.selectedWICommitteeSubcommitteeSection) {
            setSelectedWICommitteeSubcommitteeSection(props.wiAdvanceSearchFormData.selectedWICommitteeSubcommitteeSection);
            formFieldData.selectedWICommitteeSubcommitteeSection = props.wiAdvanceSearchFormData.selectedWICommitteeSubcommitteeSection;
        }
        if (props.wiAdvanceSearchFormData?.selectedWIStatus) {
            setSelectedWIStatus(props.wiAdvanceSearchFormData.selectedWIStatus);
            formFieldData.selectedWIStatus = props.wiAdvanceSearchFormData.selectedWIStatus;
        }
        if (props.wiAdvanceSearchFormData?.selectedStandard) {
            setSelectedStandard(props.wiAdvanceSearchFormData.selectedStandard);
            formFieldData.selectedStandard = props.wiAdvanceSearchFormData.selectedStandard;
        }
        if (quickFilter?.WorkItemShowHideSuppressed) {
            formFieldData.WorkItemShowHideSuppressed = quickFilter.WorkItemShowHideSuppressed;
        }
        if (quickFilter?.WorkItemTypeId) {
            formFieldData.WorkItemTypeId = quickFilter.WorkItemTypeId;
        }
        setFormData(formFieldData);
    }, []);

    // Commented for Future use
    // const addRemoveTypeaheadClass = (event: any) => {
    //     const keysToAddClassOn = ["Enter", "Backspace"];
    //     if (event.key === "ArrowDown") {
    //         event.target.value && setCustomClass("");
    //     }
    //     else if (keysToAddClassOn.indexOf(event.key) > -1) {
    //         setCustomClass("advance-ballot-search");
    //     }
    // }

    const submitAdvanceSearchForm = () => {
        props.setAdvWorkitemSearchFormData(formData);
        props.toggleAdvanceSearchVisibility && props.toggleAdvanceSearchVisibility();
        onAdvanceSearchSubmit(formData, AdvanceSearchFormType.Workitem);
    };

    const resetSearch = () => {
        setSelectedWI([]);
        setSelectedWITN([]);
        setSelectedStandard([]);
        setWITitle("");
        setSelectedWICommitteeSubcommitteeSection([]);
        setSelectedWIStatus("All");
        setFormData({});
        setClearAllTypeaheds(true);
        props.setAdvWorkitemSearchFormData({});
        onAdvanceSearchSubmit({},AdvanceSearchFormType.Workitem);
        resetQuickSearchSelectedWorkItemStatus(dispatch);
        resetQuickSearchSelectedWorkItemType(dispatch);
        resetQuickSearchSelectedWorkItemSuppress(dispatch);
        dispatch(commonActions.setQuickSearchSelectedUser(''));
        dispatch(commonActions.setWIExtraFields([]))
        dispatch(setGlobalSearchText(""));
        props.setAdvWorkitemSearchFormData({});
    };
    
    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        <label htmlFor="workItem">Work Item</label>
                        {(
                            <div className="form-group">
                                <Field
                                    name="AdvBallotBallotDesignation"
                                    clearTypeahead={clearAllTypeaheds}
                                    id="AdvBallotBallotDesignation"
                                    value={selectedWI}
                                    component={RenderTypeahead}
                                    disabled={!wiListData?.length}
                                    placeholder={wiListData?.length ? "Type here to select" : "Fetching records..."}
                                    data-testid="AdvBallotBallotDesignationSearch"
                                    customClass={customClass}
                                    multiple
                                    options={wiListData}
                                    selected={selectedWI}
                                    defaultValue={selectedWI}
                                    change={(value: string[]) => {
                                        setCustomClass("advance-ballot-search");
                                        if (clearAllTypeaheds) {
                                            setClearAllTypeaheds(false);
                                        }
                                        setFormData((prevState) => {
                                           return { ...prevState, selectedWI: value };
                                        });
                                        setSelectedWI(value);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <label htmlFor="WITN">WI Tracking Number</label>
                        {(
                            <div className="form-group">
                                <Field
                                    name="AdvBallotBallotDesignation"
                                    clearTypeahead={clearAllTypeaheds}
                                    id="AdvBallotBallotDesignation"
                                    value={selectedWITN}
                                    component={RenderTypeahead}
                                    disabled={!witnListData?.length}
                                    placeholder={witnListData?.length ? "Type here to select" : "Fetching records..."}
                                    data-testid="AdvBallotBallotDesignationSearch"
                                    customClass={customClass}
                                    multiple
                                    options={witnListData}
                                    selected={selectedWITN}
                                    defaultValue={selectedWITN}
                                    change={(value: string[]) => {
                                        setCustomClass("advance-ballot-search");
                                        if (clearAllTypeaheds) {
                                            setClearAllTypeaheds(false);
                                        }
                                        setFormData((prevState) => {
                                           return { ...prevState, selectedWITN: value };
                                        });
                                        setSelectedWITN(value);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <label htmlFor="committeeDesignation">WI Title</label>
                        <FormControl
                            aria-label="Search"
                            aria-describedby="basic-addon2"
                            value={wiTitle}
                            className={`astm-custom-select ${customClass}`}
                            placeholder="Click here to type"
                            onChange={(x) => {
                                setCustomClass("advance-ballot-search");
                                if (clearAllTypeaheds) {
                                    setClearAllTypeaheds(false);
                                }
                                const value = x?.currentTarget?.value;
                                if (typeof value === "string") {
                                    setWITitle(value);
                                    setFormData((prevState) => ({
                                        ...prevState,
                                        wiTitle: value,
                                    }));
                                }
                            }}
                            data-testid="workItemSearch"
                            style={{height: '32px'}}
                        />
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <label htmlFor="committeeDesignation">Committee Designation</label>
                        {(
                            <div className="form-group">
                                <Field
                                    name="AdvBallotCommitteeDesignation"
                                    clearTypeahead={clearAllTypeaheds}
                                    id="AdvBallotCommitteeDesignation"
                                    component={RenderTypeahead}
                                    placeholder="Type here to select"
                                    customClass={customClass}
                                    multiple
                                    options={committeeData}
                                    selected={selectedWICommitteeSubcommitteeSection}
                                    defaultValue={selectedWICommitteeSubcommitteeSection}
                                    change={(value: string[]) => {
                                        setCustomClass("advance-ballot-search");
                                        if (clearAllTypeaheds) {
                                            setClearAllTypeaheds(false);
                                        }
                                        setFormData((prevState) => {
                                            return { ...prevState, selectedWICommitteeSubcommitteeSection: value };
                                        });
                                        setSelectedWICommitteeSubcommitteeSection(value);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <label htmlFor="wiStatus">WI Status</label>
                        <select
                            onChange={(e) => {
                                setSelectedWIStatus(e.target.value);
                                setFormData((prev) => {
                                    return { ...prev, selectedWIStatus: e.target.value };
                                });
                            }}
                            disabled={props.wiStatusOption?.length === 1}
                            value={selectedWIStatus}
                            className={`custom-select astm-custom-select ${customClass}`}
                            data-testid = "SelectStatus"
                            style={{height: '32px'}}
                        >
                            {props.wiStatusOption?.map((status) => (
                              <option key={status.key} value={status.value}>
                                {status.text}
                              </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <label htmlFor="standardDesignation">Standard Designation</label>
                        {(
                            <div className="form-group">
                                <Field
                                    name="AdvBallotBallotDesignation"
                                    clearTypeahead={clearAllTypeaheds}
                                    disabled={!standardOptions?.length}
                                    id="AdvBallotBallotDesignation"
                                    value={selectedStandard}
                                    component={RenderTypeahead}
                                    placeholder={standardOptions.length ? "Type here to select" : "Fetching records..."}
                                    data-testid="AdvBallotBallotDesignationSearch"
                                    customClass={customClass}
                                    multiple
                                    options={standardOptions}
                                    labelKey="label"
                                    selected={selectedStandard}
                                    defaultValue={selectedStandard}
                                    change={(value: string[]) => {
                                        setCustomClass("advance-ballot-search");
                                        if (clearAllTypeaheds) {
                                            setClearAllTypeaheds(false);
                                        }
                                        setFormData((prevState) => {
                                           return { ...prevState, selectedStandard: value };
                                        });
                                        const filteredArray = standardListData.filter(
                                            (option: any) =>
                                                !value.some(
                                                (filterOption: any) =>
                                                    option.label === filterOption.label && option.searchValue === filterOption.searchValue
                                                )
                                            );
                                        setStandardOptions(filteredArray);
                                        setSelectedStandard(value);
                                    }}
                                    filterBy={(option, props) => {
                                        const input = props.text.toUpperCase().replace(/\s+/g, "");
                                        return (
                                            option.label.toUpperCase().includes(input) ||
                                            option.searchValue?.toUpperCase().includes(input)
                                        );
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 mt16  adv-filter-buttons">
                    <button type="button" ref={advSearchButtonRef} className="btn btn-warning mr-2 astm-btn btn-primary" data-testid="submitAdvanceSearchFormButton" onClick={() => submitAdvanceSearchForm()}>
                        Search
                    </button>
                    <button onClick={resetSearch} data-testid="resetFormButton" className="btn astm-btn btn-light">
                        Reset
                    </button>
                </div>
            </div>
        </>
    );
};

export default reduxForm<{}, Props>({
    form: "AdvanceSearchWorkitem",
})(AdvanceSearchWorkitem);
